import { useEffect, useState } from "react";

const toAu = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

const toIso = (au) => {
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(au.trim());
  if (!m) return null;
  const [, d, mo, y] = m;
  const iso = `${y}-${mo.padStart(2, "0")}-${d.padStart(2, "0")}`;
  const dt = new Date(`${iso}T00:00:00Z`);
  return dt.getUTCDate() === +d && dt.getUTCMonth() + 1 === +mo ? iso : null;
};

// Plain DD/MM/YYYY text box; emits ISO (YYYY-MM-DD) or "" when cleared.
export const DateInput = ({ value, onChange, testid, className = "", placeholder = "DD/MM/YYYY" }) => {
  const [text, setText] = useState(toAu(value));
  useEffect(() => { if (toIso(text) !== value) setText(toAu(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const bad = text.trim() !== "" && !toIso(text);
  const change = (e) => {
    const t = e.target.value.replace(/[^\d/]/g, "").slice(0, 10);
    setText(t);
    onChange(toIso(t) || "");
  };
  const blur = () => { if (!toIso(text)) setText(toAu(value)); };
  return (
    <input data-testid={testid} type="text" inputMode="numeric" value={text} onChange={change} onBlur={blur} placeholder={placeholder}
      aria-invalid={bad} title="Day/Month/Year"
      className={`font-mono w-[7.5rem] ${bad ? "!border-rose-500/70" : ""} ${className}`} />
  );
};
